{
    "name": "attack_demo",
    "actionTrace": [
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "princess",
            "position": {
                "x": 15,
                "y": 13,
                "z": 1
            },
            "performerPosition": {
                "x": 15,
                "y": 14,
                "z": 1
            }
        }
    ],
    "deltastageSum": {
        "units": {
            "princess": {
                "key": "princess",
                "jobKey": "sword",
                "affiliation": "good",
                "isRecruited": true,
                "maxhealth": 50,
                "moverange": 2,
                "skills": [
                    "inflict-damage",
                    "rally",
                    "recruit"
                ],
                "name": "PRINCESS",
                "faceKey": "human",
                "bodyKey": "good",
                "dialogue": {
                    "death": "Damn."
                },
                "portraits": {
                    "neutral": "./RP-neutral2-ZK5JV6ZJ.png",
                    "angry": "./RP-angry-AJ6PJQEY.png",
                    "happy": "./RP-happy-HEYINXAH.png"
                },
                "position": {
                    "mode": "absolute",
                    "x": 15,
                    "y": 14,
                    "z": 1
                },
                "spawnspot": {
                    "position": {
                        "x": 14,
                        "y": 15,
                        "z": 1
                    },
                    "key": "gEJIW",
                    "tag": "spawn"
                },
                "experience": 10,
                "health": 20,
                "state": "aggroed",
                "energy": {
                    "key": "princess",
                    "energy": {
                        "move": false,
                        "invoke skill": false
                    }
                }
            },
            "tJAOh": {
                "key": "tJAOh",
                "health": 5,
                "position": {
                    "mode": "absolute",
                    "x": 15,
                    "y": 13,
                    "z": 1
                },
                "state": "aggroed",
                "experience": 10
            }
        },
        "dialogue": {},
        "audio": {},
        "type": "particle",
        "text": {
            "string": "EFFECTIVE",
            "font": "numbers"
        },
        "opacity": 0,
        "flags": {
            "tutorial:hasAttacked": true,
            "tutorial:hasAttackedIneffectively": true,
            "tutorial:AttackerColor": "red",
            "tutorial:AttackedColor": "blue",
            "tutorial:hasBeenAttacked": true,
            "tutorial:hasBeenAttackedInCounterattack": true
        }
    },
    "sequenceLengthRemaining": 0,
    "chapterSlug": "demo",
    "player": {
        "affiliation": "good",
        "inventory": {
            "gold": 0
        },
        "party": {
            "units": {
                "princess": {
                    "key": "princess",
                    "jobKey": "sword",
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 50,
                    "moverange": 2,
                    "skills": [
                        "inflict-damage",
                        "rally",
                        "recruit"
                    ],
                    "name": "PRINCESS",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    },
                    "portraits": {
                        "neutral": "./RP-neutral2-ZK5JV6ZJ.png",
                        "angry": "./RP-angry-AJ6PJQEY.png",
                        "happy": "./RP-happy-HEYINXAH.png"
                    }
                },
                "hero": {
                    "key": "hero",
                    "jobKey": "hammer",
                    "aliases": [
                        "Himmel",
                        "paladin",
                        "Masked Man"
                    ],
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 50,
                    "skills": [
                        "inflict-damage",
                        "smite",
                        "recruit"
                    ],
                    "name": "HERO",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    }
                },
                "friend": {
                    "key": "friend",
                    "jobKey": "bow",
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 40,
                    "skills": [
                        "inflict-damage",
                        "pull",
                        "recruit"
                    ],
                    "name": "FRIEND",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    }
                },
                "aide": {
                    "key": "aide",
                    "jobKey": "dagger",
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 40,
                    "skills": [
                        "inflict-damage",
                        "swap",
                        "recruit"
                    ],
                    "name": "AIDE",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    }
                }
            }
        }
    },
    "gameSlug": "war",
    "randomSeed": "PJf1F6Dq4xkLhziCYKGvs",
    "captureDate": 1737072844764,
    "data": {}
}
